import axios, { AxiosError, AxiosRequestConfig } from "axios"
import { FIELDS } from "lib"
import {
  PATH_MASS,
  PATH_RETENTION,
  PATH_UPLOAD,
  PATH_VENSECAR,
} from "../../constants/paths"
import {
  requestInterceptorSuccessCredentials,
  requestInterceptorErrorSecurityCredentials,
  responseInterceptorSuccessCredentials,
  responseInterceptorErrorCredentials,
} from "interceptors"

const instance = axios.create({
  baseURL: process.env.REACT_APP_DOCUMENTS_API_SERVICE_DOMAIN,
})
instance.interceptors.request.use(
  requestInterceptorSuccessCredentials,
  requestInterceptorErrorSecurityCredentials
)

instance.interceptors.response.use(
  responseInterceptorSuccessCredentials,
  responseInterceptorErrorCredentials
)

const formDataConfig: AxiosRequestConfig = {
  headers: {
    "Content-Type": "multipart/form-data",
  },
}

export const uploadExcelFile = async (file: any) => {
  const formData = new FormData()
  formData.append(FIELDS.file.key, file)
  try {
    const result = await instance.post(
      PATH_VENSECAR + PATH_RETENTION + PATH_MASS + PATH_UPLOAD,
      formData,
      formDataConfig
    )
    return result.status
  } catch (error: any) {
    const e: AxiosError = error
    return e.response?.status || 0
  }
}

export const uploadExcelFilesConciliationService = async (
  file1: File,
  file2: File
) => {
  const formData = new FormData()
  formData.append("coupaFile", file1)
  formData.append("s21File", file2)
  try {
    const result = await instance.post(
      "/upload/mass/files",
      formData,
      formDataConfig
    )
    return result.status
  } catch (error: any) {  
    const e: AxiosError = error
    return e.response?.status || 0
  }
}
